import React from 'react';
import { Create, FormDataConsumer, FormTab, maxLength, minLength, ReferenceInput, required, SelectInput, TabbedForm, TextInput } from 'react-admin';

const hexString = (message = 'Must be a hexadecimal value') => value => value === undefined || value.match(/^[a-fA-F0-9]+$/) ? undefined : message;
const identifier = (message = 'Can only contain alphanumerical characters, minus signs, and underscores') => value => value === undefined || value.match(/^[a-zA-Z0-9][a-zA-Z0-9\-_.]*$/) ? undefined : message;

export default props => (
    <Create title='Device' {...props}>
        <TabbedForm>
            <FormTab label="Summary">
                <TextInput fullWidth={true} label="EUI" source="eui" validate={[required(), hexString(), minLength(16), maxLength(16)]} />
                <TextInput fullWidth={true} source="destination" type="url" />
                <TextInput fullWidth={true} source="group" />
                <TextInput fullWidth={true} source="name" validate={[identifier()]} />
            </FormTab>
            <FormTab label="LoRa">
                <SelectInput
                    defaultValue="ABP" fullWidth={true} label="Mode" source="lora.encryption.mode" choices={[
                    { id: 'ABP', name: 'ABP' },
                    { id: 'OTAA', name: 'OTAA' }
                ]}
                />
                <FormDataConsumer>
                    {({ formData }) =>
                        formData.lora && formData.lora.encryption && formData.lora.encryption.mode === 'ABP' ?
                            <span>
                                <TextInput fullWidth={true} label="AppSKey" source="lora.encryption.appSKey" validate={[required(), hexString(), minLength(32), maxLength(32)]} />
                                <TextInput fullWidth={true} label="DevAddr" source="lora.encryption.devAddr" validate={[required(), hexString(), minLength(8), maxLength(8)]} />
                                <TextInput fullWidth={true} label="NwkSKey" source="lora.encryption.nwkSKey" validate={[required(), hexString(), minLength(32), maxLength(32)]} />
                            </span> :
                            <span>
                                <TextInput fullWidth={true} label="AppEUI" source="lora.encryption.appEui" validate={[required(), hexString(), minLength(16), maxLength(16)]} />
                                <TextInput fullWidth={true} label="AppKey" source="lora.encryption.appKey" validate={[required(), hexString(), minLength(32), maxLength(32)]} />
                            </span>
                    }
                </FormDataConsumer>
                <ReferenceInput fullWidth={true} label="Network Server" reference="networkServers" source="lora.networkServer">
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <SelectInput
                    defaultValue="Stopped" fullWidth={true} label="State" source="lora.state" choices={[
                    { id: 'Stopped', name: 'Stopped' },
                    { id: 'Started', name: 'Started' }
                ]}
                />
                <SelectInput
                    defaultValue="1.0.0" fullWidth={true} label="Version" source="lora.version" choices={[
                    { id: '1.0.0', name: '1.0.0' }
                ]}
                />
            </FormTab>
            <FormTab label="SIPP">
                <TextInput fullWidth={true} label="Destination" source="sipp.destination" type="url" />
            </FormTab>
            <FormTab label="Subscription">
                <SelectInput
                    defaultValue="Postpaid" fullWidth={true} label="Subscription" source="subscription.type" choices={[
                    { id: 'Postpaid', name: 'Postpaid' }
                ]}
                />
            </FormTab>
        </TabbedForm>
    </Create>
);
